import { AxiosResponse } from 'axios';
import { format } from 'date-fns';
import { instance as axios } from 'api/axios';
import { clientDateFormat } from '../../../../entities/Trip';

import { SecurityLoadingReport } from './interfaces';

export class SecurityLoadingReportService {
  public static async getReports(branchId: string, startDate: string, endDate: string, notLoadedMode: string) {
    try {
      const url = '/Reports/loading';
      const response: AxiosResponse<SecurityLoadingReport[]> = await axios.get(url, {
        params: {
          SDate: startDate,
          EDate: endDate,
          branchId,
          notLoadedMode,
        },
      });

      return response.data.reverse();
    } catch (error: any) {
      throw error.response;
    }
  }

  public static formatReportForTable(reports: SecurityLoadingReport[]): SecurityLoadingReport[] {
    return reports.map((report) => ({
      ...report,
      departureDateTime: format(new Date(report.departureDateTime || ''), clientDateFormat),
      entryDateTime: format(new Date(report.entryDateTime || ''), clientDateFormat),
    }));
  }
}
